export const MAX_AUTO_BETS = 1000;

export const isUnlimitedAutoCount = (value) => String(value).trim() === '' || /^0+$/.test(String(value).trim());

export const parseAutoBetCount = (value) => {
  if (isUnlimitedAutoCount(value)) return Infinity;
  const text = String(value).trim(), count = Number(text);
  if (!/^\d+$/.test(text) || !Number.isSafeInteger(count) || count < 1 || count > MAX_AUTO_BETS) {
    throw new Error('Use 0 or leave blank for unlimited, or enter 1–1,000 bets.');
  }
  return count;
};

// Instant waits for settlement/commitment, but adds no artificial delay for these games.
// Other games retain their existing animation and concurrent-ball pacing.
export const autoBetDelay = (gameType, instant, turbo) => {
  if (instant && ['dice', 'mines'].includes(gameType)) return 0;
  if (gameType === 'plinko') return turbo ? 70 : 200;
  return turbo ? 40 : 120;
};